import { useRecoilValue } from "recoil";
import useSWR from "swr";
import { ifreaMediaAnalyticsDateRangeState } from "../../store/ifreaMediaAnalyticsDateRangeState";

export const useFetchTotalMediaReservations = (restaurantId?: string) => {
  const dateRange = useRecoilValue(ifreaMediaAnalyticsDateRangeState)
  const fetcherKey = restaurantId ? `ifrea_analytics/restaurants/${restaurantId}/total-media-reservations/?startDate=${dateRange.startDate}&endDate=${dateRange.endDate}` : null;
  const { data: totalMediaReservations, isLoading } = useSWR<{[key: string]: number}>(fetcherKey)
  return { totalMediaReservations, isLoading };
};

